import DOMPurify from 'dompurify';

/**
 * Sanitize an HTML string before injecting it via dangerouslySetInnerHTML.
 *
 * DOMPurify defaults are used: standard formatting tags and attributes are
 * preserved (headings, bold, italic, lists, links, images, etc.); all event
 * handlers, javascript: URIs, data: URIs, <script>, <object>, and other
 * dangerous constructs are stripped.  No ADD_ATTR / ADD_TAGS overrides are
 * applied so as not to re-open XSS vectors.
 *
 * @param {string|null|undefined} html - raw HTML from the API / DB
 * @returns {string} sanitized HTML safe to pass to __html
 */
export function sanitize(html) {
    if (!html || typeof html !== 'string') return '';
    return DOMPurify.sanitize(html);
}
